import React, { useState } from 'react';
import axios from 'axios';
import './App.css'; // Import CSS

const LoginAndGetData = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [userId, setUserId] = useState('');
  const [userName, setUserName] = useState(''); // State untuk menyimpan nama pengguna
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false); // Untuk kontrol modal pop-up

  // Fungsi untuk menangani login
  const handleLogin = async () => {
    setLoading(true);
    setError('');
    try {
      // Kirim request ke API login
      const loginResponse = await axios.post('https://api.blst.co.id/auth/login', {
        email,
        password,
      });

      // Ambil userId dan name_user dari response
      const { userId, name_user } = loginResponse.data;
      setUserId(userId);
      setUserName(name_user); // Simpan name_user ke dalam state
      console.log('User ID:', userId);
      console.log('Name User:', name_user);

      // Kirim request ke API kedua untuk mendapatkan data access presensi
      const qrcodeResponse = await axios.post('https://api.blst.co.id/presensi', {
        id: 206,
        prog: 206,
        sess: 332,
        token: '',
        id_user: userId
      });

      // Simpan hasil API kedua
      setData(qrcodeResponse.data);
      setLoading(false);

      // Tampilkan modal pop-up setelah berhasil login dan mendapatkan data
      setShowModal(true);

      // Bersihkan form setelah login sukses
      setEmail('');
      setPassword('');

    } catch (err) {
      setError('Terjadi kesalahan saat login atau mengambil data.');
      setLoading(false);
    }
  };

  // Fungsi untuk menutup modal
  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>PRESENSI EVENT BLST</h2>
        <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
          <div className="input-group">
            <label htmlFor="email">Username</label>
            <input
              type="text"
              id="email"
              placeholder="Enter your Username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Loading...' : 'CONFIRM'}
          </button>
        </form>

        {error && <p className="error-message">{error}</p>}

        {data && (
          <div className="data-container">
            <h3>SELAMAT ANDA BERHASIL PRESENSI</h3>
          </div>
        )}
      </div>

      {/* Modal Pop-Up */}
      {showModal && (
        <div className="modal">
          <div className="modal-content">
            {/* Tampilkan nama pengguna dalam pesan modal */}
            <h3> Selamat, {userName} Anda Telah Berhasil Melakukan Presensi.
            Silahkan Tunjukkan Ini Kepada Panitia.
            Terima Kasih, Dan Selamat Menikmati Acara! 😊
            </h3>
            <button onClick={closeModal}>Tutup</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginAndGetData;
